<template>
  <div :class="drawerClass" @mouseenter="openDrawer" @mouseleave="closeDrawer">
    <v-btn v-if="drawer"
      text
      class="drawer-open-button"
      @click.stop.prevent="closeDrawer">
      <v-icon :color="colorHex">fas fa-caret-right</v-icon>
    </v-btn>
    <v-btn v-else
      text
      class="drawer-open-button"
      @click.stop.prevent="openDrawer">
      <v-icon :color="colorHex">fas fa-caret-left</v-icon>
    </v-btn>
    <v-list>
      <v-list-item
        v-for="(image, index) in images"
        :class="tileClass(image)"
        :key="image.imgKey"
        @click="selectImage(index)">
        <v-list-item-content>
          <thumbnail :image="image" :index="index" />
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
import thumbnail from "../misc/Thumbnail";
import { mapGetters } from "vuex";
export default {
  name: "imageDrawer",
  components: { thumbnail },
  props: {
    currentExSrNo: Number
  },
  data() {
    return {
      drawer: false
    };
  },
  methods: {
    selectImage(index) {
      this.$store.dispatch("selectImageFromImageDrawer", index);
    },
    tileClass(selectedImage) {
      let selected =
        this.currentBrowserImage &&
        this.currentBrowserImage.imgKey === selectedImage.imgKey;
      return (selected ? "selected-image " : "") + "image-tile " + this.colorClass;
    },
    openDrawer(){
      this.drawer = true;
    },
    closeDrawer(){
      this.drawer = false;
    }
  },
  computed: {
    ...mapGetters(["browserImages", "currentBrowserImage", "imagesByExSrNo", "imageBrowserContext"]),
    drawerClass() {
      return "image-drawer-wrapper" + (this.drawer ? "" : " closed-drawer");
    },
    buttonIcon() {
      return this.drawer ? "fa-caret-right" : "fa-caret-left";
    },
    images() {
      if (this.browserImages.length == 0) {
        return this.imagesByExSrNo(this.currentExSrNo);
      }
      return this.browserImages;
    }
  }
};
</script>